import React, { useState } from "react";

import { Modal } from "reactstrap";
import { toast } from "react-toastify";

import "assets/css/home-modern.css";
import "assets/css/flow.css";

// core components
import DefaultFooter from "components/Footers/DefaultFooter.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FlowHero from "components/Flow/FlowHero";
import OrderLines from "components/Flow/OrderLines";
import { useBusySpan } from "hooks/useBusy";
import { APIRequest, contendedProducts, errorHandlerNew, handOverContended } from "utils/ApiRequest";
import { DO_NOT_CLOSE } from "utils/busyStore";
import { formatINR } from "utils/format";
import { useNavigate } from "react-router";

import heroImage from "assets/img/banner2.jpg";
import bankQr from "assets/img/sbi_qr.jpeg";
import bankLogo from "assets/img/axis.png";

const FLOW_STEPS = ["Membership", "Sponsorship", "Review & pay"];
const REFER_SOURCES = ["Facebook", "Instagram", "Google", "Other"];

const isBlank = (value) =>
  value === undefined || value === null || String(value).trim() === "";

function OrderSummary() {
  const [token, setToken] = useState(null);
  const history = useNavigate();
  const [cartRes, setCartRes] = useState(null);
  const [modalLarge, setModalLarge] = React.useState(false);
  const [modalLargeFinal, setModalLargeFinal] = React.useState(false);
  const [offlineTxnId, setOfflineTxnId] = useState(null);
  const [offlineBankName, setOfflineBankName] = useState(null);
  const [orderRcptId, setOrderRcptId] = useState(null);
  const [orderTotal, setOrderTotal] = useState(null);
  const [addrLine1, setAddrLine1] = useState(null);
  const [addrLine2, setAddrLine2] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [pin, setPin] = useState(null);
  const [emailEx, setEmailEx] = useState(null);
  const [mobileEx, setMobileEx] = useState(null);
  const [referSource, setReferSource] = useState(null);
  const [referredBy, setReferredBy] = useState(null);
  const setBusy = useBusySpan(DO_NOT_CLOSE);


  React.useEffect(() => {
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo !== null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session !== null) {
        setToken(userInfo.session);
        loadCartData(userInfo.session);
        loadUserExData(userInfo.session)
      } else {
        history("/login")
      }
    } else {
      history("/login")
    }

    return function cleanup() {
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const failWith = (err) => {
    setBusy(null);
    errorHandlerNew(err);
    const contended = contendedProducts(err);
    if (contended.length === 0) return;
    // Nothing on this page can fix a cart the server has rejected — those items are only selectable
    // back on the sponsorship step. Hand the verdict over and send them there, rather than leaving
    // them in front of a Pay button that will keep failing for a reason they cannot act on.
    handOverContended(contended);
    history("/sponsorship");
  };

  function loadCartData(token) {
    APIRequest(
      token,
      "/getCartDetails",
      {},
      (res) => {
        if (res.data === null || res.data.length === 0) history("/membership");
        setCartRes(res.data);
      },
    );
  }

  async function loadUserExData(token) {
    APIRequest(
      token,
      "/getUserExtraInfo",
      {},
      (res) => {
        let userExtra = res.data;
        if (userExtra === null) return;
        setAddrLine1(userExtra.addrLine1);
        setAddrLine2(userExtra.addrLine2);
        setCity(userExtra.city);
        setState(userExtra.state);
        setPin(userExtra.pin);
        setEmailEx(userExtra.additionalEmail);
        setMobileEx(userExtra.additionalMobile);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  async function saveUserAdditionalDetails() {
    APIRequest(
      token,
      "/saveUserExtraInfo",
      { addrLine1, addrLine2, pin, city, state, additionalEmail: emailEx, additionalMobile: mobileEx, referSource, referredBy },
      (res) => {
        console.log(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
  }


  const handleOnlineOrderNow = (e) => {
    e.preventDefault();
    if (isBlank(addrLine1) || isBlank(city) || isBlank(state) || isBlank(pin)) {
      toast.error("Please fill the mandatory(*) fields!");
      return;
    }
    setBusy("Opening the secure payment window…");
    APIRequest(
      token,
      "/startOrder",
      {
        offline: false
      },
      (res) => {
        loadRazorPay(res.data);
        saveUserAdditionalDetails();
        deleteCart();
      },
      failWith
    );
  }

  const handleOfflineOrderNow = (e) => {
    e.preventDefault();
    if (isBlank(addrLine1) || isBlank(city) || isBlank(state) || isBlank(pin)) {
      toast.error("Please fill the mandatory(*) fields!");
      return;
    }
    setBusy("Fetching the transfer details…");
    APIRequest(
      token,
      "/startOrder",
      {
        offline: true
      },
      (res) => {
        loadOfflinePay(res.data);
        saveUserAdditionalDetails();
        deleteCart();
      },
      failWith
    );
  }

  const handleUpdTxnDetails = (e) => {
    setModalLarge(false);
    setModalLargeFinal(true);
  }

  const handleOfflineUpdDetails = (e) => {
    e.preventDefault();
    if (offlineTxnId === undefined || offlineTxnId === null || offlineTxnId === "") {
      toast.error("Please add the Bank/UPI transaction id to proceed");
      return;
    }
    setBusy("Recording your transaction…");
    APIRequest(
      token,
      "/handleOfflineOrder",
      { isOffline: true, offlineTxnId, offlineBankName, orderRcptId },
      () => {
        localStorage.removeItem('selectedPrds');
        localStorage.removeItem('totalCartPrice');
        let userInfo = localStorage.getItem('user-info');
        if (userInfo != null) {
          userInfo = JSON.parse(userInfo);
          userInfo.member = true;
          localStorage.setItem('user-info', JSON.stringify(userInfo));
        }
        setBusy(null);
        toast.success('Your contribution deatils has been captured and sent for verfication, will sent you an email on once verification completes!');
        history("/profile");
      },
      failWith
    );
  }

  function loadOfflinePay(order) {
    setOrderRcptId(order.orderRcptId);
    setOrderTotal(order.orderTotalInPaisa / 100);
    setBusy(null);
    setModalLarge(true);
    setModalLargeFinal(false);
  }


  async function deleteCart() {
    APIRequest(
      token,
      "/deleteCart",
      {},
      (res) => {
        console.log(res.data);
        localStorage.removeItem('selectedPrds');
        localStorage.removeItem('totalCartPrice');
      },
    );
  }

  const handleStartOver = (e) => {
    localStorage.removeItem('selectedPrds');
    localStorage.removeItem('totalCartPrice');
    history(-1);
    history(-1);
  }

  async function loadRazorPay(order) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        const options = {
          key: 'rzp_live_7n7vOYR9yX50XZ',
          currency: order.currency,
          amount: order.orderTotalInPaisa,
          order_id: order.orderOrTokenId,
          name: 'Membership Contibution',
          description: 'Contribution for SORRBA Membership',
          image: 'https://app.sorrba.org/static/media/now-logo.9315a628.png',
          handler: function (response) {
            setBusy("Confirming your contribution…");
            APIRequest(
              token,
              "/handleSuccessOrder",
              { isOffline: false, orderId: response.razorpay_order_id, razorpayPaymentId: response.razorpay_payment_id, razorpaySignature: response.razorpay_signature },
              (res) => {
                localStorage.removeItem('selectedPrds');
                localStorage.removeItem('totalCartPrice');
                let userInfo = localStorage.getItem('user-info');
                if (userInfo != null) {
                  userInfo = JSON.parse(userInfo);
                  userInfo.member = true;
                  localStorage.setItem('user-info', JSON.stringify(userInfo));
                }
                setBusy(null);
                toast.success('Congratulations!! We received your contibution, Please check you email for datails!');
                history("/profile");
              },
              failWith
            );
          },
          modal: {
            "ondismiss": function () {
              setBusy(null);
              toast.error('Payment Failed, Please start over!');
              history(-1);
              history(-1);
            }
          },
          prefill: {
            name: order.userFullName,
            email: order.userEmail,
            contact: order.userMobile
          }
        }
        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function (response) {
          setBusy("Recording the failed attempt…");
          APIRequest(
            token,
            "/handleFailOrder",
            { orderId: response.error.metadata.order_id, razorpayPaymentId: response.error.metadata.payment_id },
            (res) => {
              localStorage.removeItem('selectedPrds');
              localStorage.removeItem('totalCartPrice');
              setBusy(null);
              toast.error('Payment failed, order couldn\'t be processed successfully!');
              history(-1);
              history(-1);
              history(-1);
            },
            failWith
          );
        });
        paymentObject.open();
        setBusy(null);
      };
      script.onerror = () => {
        setBusy(null);
        toast.error('Seems some internal issue with your network, please check your network!');
      }
      document.body.appendChild(script);
    });
  }

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <FlowHero
          image={heroImage}
          eyebrow={"Step 3 of " + FLOW_STEPS.length}
          title="Review & pay"
          lead="Check your contribution below, add your address for the receipt, and choose how you would like to pay."
          steps={FLOW_STEPS}
          activeStep={2}
        />
        <div className="main hm hm-flow">
          <section className="hm-fbody">
            <div className="hm-wrap">
              {cartRes === null && (
                <div className="hm-fstate">
                  <span className="hm-spinner" aria-hidden="true"></span>
                  <p style={{ margin: 0 }}>Loading your cart…</p>
                </div>
              )}

              {cartRes !== null && (
                <div className="hm-checkout">
                  <div className="hm-panel">
                    <div className="hm-panel-head">
                      <h2>Address & additional details</h2>
                      <p>We use this for your receipt and to stay in touch about the Pujo.</p>
                    </div>
                    <div className="hm-fgrid">
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-addr1">Door no, building / society *</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-addr1"
                            className="hm-fld-i"
                            type="text"
                            placeholder="Flat 101, Green Residency"
                            value={addrLine1 || ""}
                            onChange={(e) => setAddrLine1(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-addr2">Road, area</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-addr2"
                            className="hm-fld-i"
                            type="text"
                            placeholder="Sarjapur Outer Ring Road"
                            value={addrLine2 || ""}
                            onChange={(e) => setAddrLine2(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-city">City *</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-city"
                            className="hm-fld-i"
                            type="text"
                            placeholder="Bengaluru"
                            value={city || ""}
                            onChange={(e) => setCity(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-state">State *</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-state"
                            className="hm-fld-i"
                            type="text"
                            placeholder="Karnataka"
                            value={state || ""}
                            onChange={(e) => setState(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-pin">PIN code *</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-pin"
                            className="hm-fld-i"
                            type="text"
                            inputMode="numeric"
                            placeholder="560035"
                            value={pin || ""}
                            onChange={(e) => setPin(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-mobile">Additional mobile</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-mobile"
                            className="hm-fld-i"
                            type="tel"
                            placeholder="Optional"
                            value={mobileEx || ""}
                            onChange={(e) => setMobileEx(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-email">Additional email</label>
                        <div className="hm-fld-wrap">
                          <input
                            id="os-email"
                            className="hm-fld-i"
                            type="email"
                            placeholder="Optional"
                            value={emailEx || ""}
                            onChange={(e) => setEmailEx(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="hm-fld">
                        <label className="hm-fld-l" htmlFor="os-refer">How did you hear about us?</label>
                        <div className="hm-fld-wrap hm-fld-sel">
                          <select
                            id="os-refer"
                            className="hm-fld-s"
                            value={referSource || ""}
                            onChange={(e) => setReferSource(e.target.value)}
                          >
                            <option value="">Choose…</option>
                            {REFER_SOURCES.map((source) => (
                              <option key={source}>{source}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {referSource === "Other" && (
                        <div className="hm-fld">
                          <label className="hm-fld-l" htmlFor="os-referby">Referred by</label>
                          <div className="hm-fld-wrap">
                            <input
                              id="os-referby"
                              className="hm-fld-i"
                              type="text"
                              placeholder="Name of the person"
                              value={referredBy || ""}
                              onChange={(e) => setReferredBy(e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <aside className="hm-checkout-side">
                    <div className="hm-panel">
                      <div className="hm-panel-head">
                        <h2>Your contribution</h2>
                        <p>
                          {cartRes.selectedProducts != null ? cartRes.selectedProducts.length : 0}{" "}
                          {cartRes.selectedProducts != null && cartRes.selectedProducts.length === 1
                            ? "item"
                            : "items"}{" "}
                          in this order
                        </p>
                      </div>
                      <OrderLines cart={cartRes} />
                      <div className="hm-payopts">
                        <div className="hm-payopt">
                          <button
                            className="hm-btn hm-btn-primary"
                            type="button"
                            onClick={(e) => { handleOnlineOrderNow(e) }}
                          >
                            Pay &#x20B9;{formatINR(cartRes.totalSellPrice)} online
                          </button>
                          <small>Card, UPI or netbanking · convenience charges apply</small>
                        </div>
                        <div className="hm-payopt">
                          <button
                            className="hm-btn hm-btn-outline"
                            type="button"
                            onClick={(e) => { handleOfflineOrderNow(e) }}
                          >
                            Direct bank transfer
                          </button>
                          <small>Scan the QR or use NEFT · no convenience charges</small>
                        </div>
                      </div>
                      <p className="hm-secure">
                        <i className="now-ui-icons ui-1_lock-circle-open" aria-hidden="true"></i>
                        Payments are processed securely by Razorpay
                      </p>
                      <p className="hm-payback">
                        <button type="button" onClick={(e) => { handleStartOver(e) }}>
                          Start over
                        </button>
                      </p>
                    </div>
                  </aside>
                </div>
              )}
            </div>
          </section>
        </div>
        <DefaultFooter />
      </div>

      <Modal isOpen={modalLarge} size="lg" centered scrollable contentClassName="hm-modal">
        <div className="hm-modal-head">
          <div>
            <span className="hm-modal-eyebrow">Direct transfer</span>
            <h5 className="hm-modal-title">Scan the QR or transfer to our account</h5>
          </div>
        </div>
        <div className="hm-modal-body">
          <div className="hm-amount-due">
            <span>Amount to transfer</span>
            <b>&#x20B9;{formatINR(orderTotal)}</b>
          </div>
          <div className="hm-paygrid">
            <div className="hm-qr">
              <span className="hm-qr-l">Scan to pay</span>
              <img alt="Payment QR code" src={bankQr} />
            </div>
            <div className="hm-bank">
              <img className="hm-bank-logo" alt="Axis Bank" src={bankLogo} />
              <dl>
                <div>
                  <dt>Account payee</dt>
                  <dd>Sarjapur Outer Ring Road Bengali Association</dd>
                </div>
                <div>
                  <dt>Account number</dt>
                  <dd className="is-num">912010038909637</dd>
                </div>
                <div>
                  <dt>IFSC code</dt>
                  <dd className="is-num">UTIB0002145</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-primary" type="button" onClick={(e) => { handleUpdTxnDetails(e) }}>
            I have paid — add transaction details
          </button>
        </div>
      </Modal>

      <Modal isOpen={modalLargeFinal} centered contentClassName="hm-modal">
        <div className="hm-modal-head">
          <div>
            <span className="hm-modal-eyebrow">Almost done</span>
            <h5 className="hm-modal-title">Share your transaction details</h5>
          </div>
        </div>
        <div className="hm-modal-body">
          <p>
            Enter the reference for your transfer of <b>&#x20B9;{formatINR(orderTotal)}</b>. Our team
            verifies it and emails you a confirmation.
          </p>
          <div className="hm-fform">
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="os-txn">Bank / UPI transaction ID *</label>
              <div className="hm-fld-wrap">
                <input
                  id="os-txn"
                  className="hm-fld-i"
                  type="text"
                  placeholder="e.g. 402912345678"
                  onChange={(e) => setOfflineTxnId(e.target.value)}
                />
              </div>
            </div>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="os-bank">Bank name</label>
              <div className="hm-fld-wrap">
                <input
                  id="os-bank"
                  className="hm-fld-i"
                  type="text"
                  placeholder="e.g. HDFC Bank"
                  onChange={(e) => setOfflineBankName(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-primary" type="button" onClick={(e) => { handleOfflineUpdDetails(e) }}>
            Submit details
          </button>
        </div>
      </Modal>

    </>
  );
}

export default OrderSummary;
